/** /managerDashboard/stats/highest-operator-milestone-reached-savings
 * @see https://github.com/search?q=repo%3ASignolteam/managers_service%20OperatorMilestoneHighestSavingsResponseDto
 */
export const getHighestOperatorMilestoneTotalsRespAviation = () => {
  const savingsKgCO2 = 265000;
  return {
    maxOperatorMilestoneSavings: {
      co2Kg: savingsKgCO2,
      co2Tonnes: savingsKgCO2 / 1000,
      fuelKg: savingsKgCO2 / 3.16,
      fuelTonnes: savingsKgCO2 / 3.16 / 1000,
    },
  };
};
